import { AutomaticAcceptanceTimingWidget as AutomaticAcceptanceTimingWidgetBase } from '@procureai/ui-modules-mui';

import { I18nNamespace } from '~/common/types';

import { useAutomaticAcceptanceTimingWidgetBackend } from './AutomaticAcceptanceTimingWidget.hooks.tsx';

const i18n = {
  ns: I18nNamespace.widgets,
  keyPrefix: 'AutomaticAcceptanceTimingWidget',
};

export const AutomaticAcceptanceTimingWidget = () => {
  return (
    <AutomaticAcceptanceTimingWidgetBase
      useBackend={useAutomaticAcceptanceTimingWidgetBackend}
      intercomTarget={i18n.keyPrefix}
      i18n={i18n}
    />
  );
};
